import { useState } from "react";

import { FooterModal } from "components/common/modal/Footer";
import RadioButton from "components/common/RadioButton";
import { Body } from "components/common/modal/Body";
import { HeaderModal } from "components/common/modal/Header";
import { Modal } from "components/common/modal/Modal";

import allImgPaths from "assets/images";
import CustomCheckBox from "components/CustomCheckBox";

const RfpVendorBoxModal = ({ isShowModal, setIsShowModal }: any) => {

    let radioOptionsExternal = [
        {
            label: "External Vendor",
            value: "external_vendor",
        }
    ]

    let radioOptionsFavorite = [
        {
            label: "From Favorites",
            value: "from_favorites",
        }
    ]

    const vendorDataFavorite = [
        {
            mainTitle: 'Picked from favorite',
        },

        {
            mainTitle: 'Picked from favorite',
        },

        {
            mainTitle: 'Picked from favorite',
        },

        {
            mainTitle: 'Picked from favorite',
        },
    ]

    const vendorDataExternal = [
        {
            mainTitle: 'Event Venue',
        },
        {
            mainTitle: 'Accommodation',
        },
        {
            mainTitle: 'Activities and Experiences',
        },
        {
            mainTitle: 'Decore and Rental',
        },
        {
            mainTitle: 'Gifting',
        },
        {
            mainTitle: 'Entertainment',
        },
        {
            mainTitle: 'Technology Partner',
        },
        {
            mainTitle: 'Security and Staffing',
        },
        {
            mainTitle: 'Marketing and Promotion',
        },
        {
            mainTitle: 'All of the Above',
        },
    ]

    const [selectedOption, setSelectedOption] = useState('from_favorites');
    const [boxSelected, setBoxSelected] = useState(true);
    const [showDropdownDataSelectVendor, setshowDropdownDataSelectVendor] = useState(false);
    const [showDropdownDataVendorFor, setshowDropdownDataVendorFor] = useState(false);
    const [showDropDown, setShowDropDown] = useState(0);

    const handleDropdownData = () => {
        setshowDropdownDataSelectVendor(!showDropdownDataSelectVendor);
    }

    const handleDropdownDataVendorFor = () => {
        setshowDropdownDataVendorFor(!showDropdownDataVendorFor);
    }

    const handleOptionChange = (value: string) => {
        setSelectedOption(value);
        setBoxSelected(value === 'external_vendor');
    };

    const handleDropDown = (index: any) => {
        setShowDropDown(index);
    }

    return (
        <>
            {/* Modal */}
            <Modal
                className='modal-wrapper max-w-[480px]'
                isShow={isShowModal}
            >
                <form>
                    <HeaderModal
                        title="Fete Settings"
                        isShowHeader={true}
                        className="modal-header pt-6 px-6 pb-5 border-b border-[#EAECF0]"
                    >
                        <div className="flex items-center justify-between">
                            <h2 className="text-lg text-[#101828] font-interSemiBold leading-none pb-1.5">
                                Add Vendor
                            </h2>
                            {/* Close Icon */}
                            <img
                                className="modal-close modal-toggle cursor-pointer hover:bg-[#f2f4f7] rounded w-5 p-1"
                                id="modal-toggle"
                                src={allImgPaths.closeIcon}
                                // onClick={onCloseModal}
                                alt="close icon"
                            />
                        </div>

                    </HeaderModal>

                    <Body title="" isShowBody={true} className="modal-body pl-6 pr-5 pt-5 max-h-[calc(100vh_-_448px)] overflow-y-scroll scrollbar-adjust">
                        <div className="mb-6">
                            <div className="flex gap-x-5 mb-8">
                                <div className="">
                                    <RadioButton
                                        options={radioOptionsExternal}
                                        selectedOption={selectedOption}
                                        onOptionChange={handleOptionChange}
                                    />
                                </div>
                                <div className="">
                                    <RadioButton
                                        options={radioOptionsFavorite}
                                        selectedOption={selectedOption}
                                        onOptionChange={handleOptionChange}
                                    />
                                </div>
                            </div>

                            {/* External Vendor */}
                            {
                                boxSelected &&
                                <div>
                                    <div className="mb-5">
                                        <div>
                                            <label htmlFor="email" className="text-sm font-interMedium text-[#344054] pb-2 inline-block">
                                                Email
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="input-field border border-[#D0D5DD] block w-full "
                                                    name="email"
                                                    type="email"
                                                    id="email"
                                                    placeholder="Enter Your Email"
                                                    autoComplete="off"
                                                    defaultValue=""
                                                />
                                            </div>
                                            <p className='text-sm text-[#667085] pt-1.5'>Add the vendor using email</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div>
                                            <label htmlFor="email" className="text-sm font-interMedium text-[#344054] pb-2 inline-block">
                                                Vendor for
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="input-field border border-[#D0D5DD] block w-full down-arrow !pr-10"
                                                    name="email"
                                                    type="email"
                                                    id="email"
                                                    onClick={handleDropdownDataVendorFor}
                                                    placeholder="Select from list"
                                                    autoComplete="off"
                                                />

                                                <div className={`${showDropdownDataVendorFor ? "block" : "hidden"} rounded-lg px-2 py-2 shadow-lg absolute bg-[#fff] z-20 w-full max-h-[200px] overflow-y-auto`}>
                                                    <div className="pt-1">
                                                        <ul>
                                                            {vendorDataExternal.map((item, index): any => (
                                                                <li key={index} className='mb-6 last:mb-0 pl-3 flex items-center gap-x-2'>
                                                                    <span className="checkbox-alignment">
                                                                        <CustomCheckBox
                                                                            name=""
                                                                            label={item.mainTitle}
                                                                            checked={false}
                                                                            customLabelStyle="text-sm text-[#475467] pl-2 font-interRegular"
                                                                            customStyle=""
                                                                            onChange={() => { }}
                                                                        />
                                                                    </span>
                                                                </li>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='text-sm text-[#667085] pt-1.5'>What service will this vendor provide</p>
                                        </div>
                                    </div>

                                </div>
                            }

                            {/* From Favorites */}
                            {
                                !boxSelected &&
                                <div>
                                    <div className="mb-5">
                                        <div>
                                            <label htmlFor="email" className="text-sm font-interMedium text-[#344054] pb-2 inline-block">
                                                Select Vendor
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="input-field border border-[#D0D5DD] block w-full down-arrow !pr-10"
                                                    name="email"
                                                    type="email"
                                                    id="email"
                                                    onClick={handleDropdownData}
                                                    placeholder="Select from list"
                                                    autoComplete="off"
                                                />

                                                <div className={`${showDropdownDataSelectVendor ? "block" : "hidden"} rounded-lg px-2 py-2 shadow-lg absolute bg-[#fff] z-20 w-full max-h-[200px] overflow-y-auto`}>
                                                    <div className="">
                                                        <ul>
                                                            <li className='text-sm text-[#475467] mb-6 last:mb-0 pl-3'>SoHo Loft Penthouse at Penthouse Six Rooftop</li>
                                                            <li className='text-sm text-[#475467] mb-6 last:mb-0 pl-3'>Grand Hyatt Banquet Hall</li>
                                                            <li className='text-sm text-[#475467] mb-6 last:mb-0 pl-3'>Rooftop by Creatures</li>
                                                            <li className='text-sm text-[#475467] mb-6 last:mb-0 pl-3'>Peace Lily Beach Resort</li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='text-sm text-[#667085] pt-1.5'>Choose the vendor from your favorite list</p>
                                        </div>
                                    </div>

                                    <div className="">
                                        <div>
                                            <label htmlFor="email" className="text-sm font-interMedium text-[#344054] pb-2 inline-block">
                                                Vendor for
                                            </label>
                                            <div className="relative">
                                                <input
                                                    className="input-field border border-[#D0D5DD] block w-full down-arrow !pr-10"
                                                    name="email"
                                                    type="email"
                                                    id="email"
                                                    onClick={handleDropdownDataVendorFor}
                                                    placeholder="Select from list"
                                                    autoComplete="off"
                                                />
                                                <div className={`${showDropdownDataVendorFor ? "block" : "hidden"} rounded-lg px-2 py-2 shadow-lg absolute bg-[#fff] z-20 w-full max-h-[200px] overflow-y-auto`}>
                                                    <div className="">
                                                        <ul>
                                                            {vendorDataFavorite.map((item, index): any => (
                                                                <li key={index} className='mb-6 last:mb-0 pl-3'>
                                                                    <span onClick={() => handleDropDown(index)} className='text-sm text-[#475467] flex items-center justify-between cursor-pointer font-interMedium'>
                                                                        {item.mainTitle}
                                                                    </span>
                                                                </li>
                                                            ))}

                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <p className='text-sm text-[#667085] pt-1.5'>What service will this vendor provide</p>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    </Body>

                    <FooterModal
                        title=""
                        isShowFooter={true}
                        className="modal-footer pt-4 px-6 pb-4 border-t border-[#EAECF0]"
                    >
                        <div className="flex items-center gap-x-3 justify-center">
                            <button
                                type="button"
                                // onClick={onCloseModal}
                                className=" text-[#344054] font-interSemiBold border border-[#D0D5DD] rounded-lg tracking-wide py-2.5 px-2.5 !text-base flex-1 hover:bg-[#f2f4f7]"
                            >
                                Cancel
                            </button>
                            <button className="!text-base text-white bg-[#1E0AF5] hover:bg-[#120693] font-interSemiBold rounded-lg  px-3.5 py-2.5 flex-1"
                            >
                                Add
                            </button>
                        </div>
                    </FooterModal>
                </form>
            </Modal >
        </>
    );
};

export default RfpVendorBoxModal;
